import { ChangeEvent, useState } from 'react';

import { MinMaxNumberValues } from '../../../../apis/graphql/types';
import { FilterFooter } from '../Footer/FilterFooter';
import {
  StyledContentWrapper,
  StyledError,
  StyledInputWrapper,
  StyledMaxInput,
  StyledMinInput,
  StyledText,
} from './styled';

type Props = {
  choosenData?: MinMaxNumberValues;
  showCurrency?: boolean;
  handleCloseFilter: () => void;
  handleApplyFilter: (obj: MinMaxNumberValues) => void;
};

const FilterContent = ({ choosenData, showCurrency, handleCloseFilter, handleApplyFilter }: Props): JSX.Element => {
  const [min, setMin] = useState(choosenData?.min);
  const [max, setMax] = useState(choosenData?.max);
  const [error, setError] = useState(false);

  const isFilterEmpty = !choosenData?.min && !choosenData?.max && !min && !max;

  const handleFilter = (): void => {
    const filterValue = { min: min || null, max: max || null };
    handleApplyFilter(filterValue);
  };

  const handleMin = (e: ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget.value !== '' ? Number(e.currentTarget.value) : undefined;
    setMin(value);
    validate(value, max);
  };

  const handleMax = (e: ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget.value !== '' ? Number(e.currentTarget.value) : undefined;
    setMax(value);
    validate(min, value);
  };

  const validate = (min?: number | null, max?: number | null): void => {
    const error = min && max && Number(min) >= Number(max);
    setError(Boolean(error));
  };

  return (
    <>
      <StyledContentWrapper>
        <StyledText $error={error}>Min</StyledText>
        <StyledText $error={error}>Max</StyledText>
        <StyledInputWrapper data-testid="minInputWrapper" $showCurrency={!!showCurrency}>
          <StyledMinInput
            data-testid="minInput"
            type="number"
            $error={error}
            defaultValue={choosenData?.min || undefined}
            onBlur={handleMin}
          ></StyledMinInput>
        </StyledInputWrapper>
        <StyledInputWrapper data-testid="maxInputWrapper" $showCurrency={!!showCurrency}>
          <StyledMaxInput
            type="number"
            data-testid="maxInput"
            $error={error}
            defaultValue={choosenData?.max || undefined}
            onBlur={handleMax}
          ></StyledMaxInput>
        </StyledInputWrapper>
      </StyledContentWrapper>
      {error && <StyledError data-testid="errorMessageFilter">Min must be lower than the max</StyledError>}
      <FilterFooter
        isDisabled={error || isFilterEmpty}
        handleApplyFilter={handleFilter}
        handleCloseFilter={handleCloseFilter}
      />
    </>
  );
};

export default FilterContent;
